<template>
  <section class="mt-2">
    <v-dialog persistent v-model="formDialogVisible" max-width="400px">
      <v-card>
        <v-form ref="form" v-model="valid">
          <v-toolbar color="grey lighten-3 font-weight-bold " flat dense>
            <span class="subtitleFontsize">{{ formTitle }}</span>
            <v-spacer></v-spacer>
            <v-btn depressed small icon @click="closeFormDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="pt-0">
            <v-row no-gutters>
              <v-col cols="12" md="12">
                <label class="my-0 rounded labelFontsize required"> Currency Name </label>
                <v-autocomplete
                  v-model="allowedCurrencyObj.currency_name"
                  placeholder="Currency Name"
                  dense
                  outlined
                  class="rounded"
                  :rules="Currency_Name"
                  :items="currencyOptions"
                  @input="updateCurrencyCode"
                ></v-autocomplete>

                <label class="my-0 rounded labelFontsize required"> Currency Code </label>
                <v-text-field
                  v-model="allowedCurrencyObj.currency_code"
                  dense
                  disabled
                  outlined
                  placeholder="Currency Code"
                  class="rounded"
                  :rules="Currency_Code"
                >
                </v-text-field>

                <label class="my-0 rounded labelFontsize required"> Applied For </label>
                <v-autocomplete
                  v-model="allowedCurrencyObj.applied_for"
                  placeholder="Applied For "
                  dense
                  outlined
                  class="rounded"
                  :items="appliedfor"
                  :rules="Applied_For"
                ></v-autocomplete>
                <!-- <label class="my-0 rounded labelFontsize"> Is Default </label>
                <v-autocomplete
                  v-model="allowedCurrencyObj.is_default"
                  placeholder="Is Default"
                  dense
                  outlined
                  class="rounded"
                  :items="[
                    { text: 'Reciever', value: 1 },
                    { text: 'Send', value: 2 },
                  ]"
                  :items="[
                    { text: 'Yes', value: true },
                    { text: 'No', value: false },
                  ]"
                  :rules="Is_Default"
                ></v-autocomplete> -->
                <v-switch
                  v-model="allowedCurrencyObj.is_default"
                  color="success"
                  class="ma-0 pa-0 add-check"
                  hide-details
                  label="Is Default"
                ></v-switch>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider class="pa-0 ma-0"></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              depressed
              small
              color="primary"
              class="text-capitalize"
              outlined
              @click="closeFormDialog"
            >
              <v-icon small class="me-2">mdi-close-circle-outline</v-icon> Cancel
            </v-btn>
            <v-btn
              depressed
              @click="submit()"
              small
              color="primary"
              class="text-capitalize"
            >
              <v-icon small class="me-2">mdi-content-save-check-outline</v-icon> Save
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <template>
      <v-row class="mt-5">
        <v-btn
          depressed
          class="text-capitalize ms-8 me-3"
          small
          color="primary"
          @click="openFormDialog"
        >
          <v-icon small class="me-2">mdi-content-save-plus-outline</v-icon>Add
        </v-btn>
        <v-btn depressed @click="downloadExcelsheet" color="primary" small
          ><v-icon small>mdi-file-excel-outline</v-icon>Export
        </v-btn>
        <v-spacer></v-spacer>

        <v-col cols="12" lg="4" xs="12">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Type here to filter the table data."
            single-line
            class="me-4 mx-2"
            dense
            clearable
          ></v-text-field>
        </v-col>
      </v-row>
    </template>
    <v-data-table fixed-header  height="55vh"
      :headers="headers"
      dense
      :search="search"
      class="p-1"
      :loading="isLoading"
      loading-text="Loading... Please wait"
      :items="AllpartnerCurrency"
    >
      <template v-slot:item.is_default="{ item }">
        <v-switch
          v-model="item.is_default"
          height="0px"
          color="success"
          dense
          @click="isactiveupdate(item)"
        ></v-switch>
      </template>
      <template v-slot:item.applied_for="{ item }">
        {{ getAppliedForText(item.applied_for) }}
      </template>

      <template v-slot:item.actions="{ item, index }">
        <v-icon small color="primary" class="mr-2" @click="editItem(item)">
          mdi-content-save-edit-outline
        </v-icon>
        <v-icon small color="primary" @click="deleteItem(index)">
          mdi-trash-can-outline
        </v-icon>
      </template>
    </v-data-table>
    <v-dialog persistent v-model="dialogDelete" width="500">
      <v-card>
        <v-card-title class="border border-bottom">Delete</v-card-title>
        <v-card-text class="h5 py-3"
          >Are you sure you want to delete this prameter?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed small color="primary" outlined @click="deleteItemConfirm">
            <v-icon>mdi-check</v-icon>
          </v-btn>
          <v-btn depressed small color="primary" outlined @click="closeDelete"
            ><v-icon>mdi-close</v-icon></v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <loading :active="loader" :opacity="0.9" color="#ff6b00" />
  </section>
</template>

<script>
import alerts from "@/mixins/alerts";
import Loading from "vue-loading-overlay";
import partnerService from "@/services/partnerService/partnerService.js";
import setupService from "@/services/SetupService/setupService";
import { AllowedCurrency } from "@/utils/validation";
export default {
  name: "Alloedcurrency",
  mixins: [alerts],
  data() {
    return {
      ...AllowedCurrency,
      search: "",
      valid: true,
      formDialogVisible: false,
      loader: false,
      dialogDelete: false,
      isLoading: false,
      partnerId: null,
      currencyid: null,
      itemToDelete: null,
      AllpartnerCurrency: [],
      currencyOptions: [],
      Currencybyid: [],
      appliedfor: [
        { text: "Reciever", value: "1" },
        { text: "Send", value: "2" },
      ],
      allowedCurrencyObj: {
        id: null,
        partner_id: null,
        country: "",
        currency_code: "",
        currency_name: "",
        is_default: null,
        applied_for: "",
      },
      editedIndex: -1,
      defaultItem: {
        partner_id: null,
        country: "",
        currency_code: "",
        currency_name: "",
        is_default: null,
        applied_for: "",
      },
      headers: [
        {
          text: "Currency Code",
          value: "currency_code",
        },
        { text: "Currency Name", value: "currency_name" },
        { text: "Applied For", value: "applied_for" },
        { text: "Is default", value: "is_default" },
        { text: "Created By", value: "created_by", sortable: false },
        { text: "Action", value: "actions", sortable: false },
      ],
    };
  },

  components: {
    Loading,
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Add Currency" : "Edit Currency";
    },
  },
  mounted() {
    this.partnerId = this.$route.query.partner_id;
    console.log("partnerId", this.partnerId);
    this.getAllcurrency();
    this.getcurrencyList();
    localStorage.getItem("companyCountryCode");
  },
  methods: {
    async downloadExcelsheet() {
      if (this.AllpartnerCurrency) {
        this.exportToExcel(
          this.headers,
          this.AllpartnerCurrency,
          "Agent partnerCurrency"
        );
      }
    },
    getAppliedForText(value) {
      const appliedForOptions = [
        { value: "1", text: "Receiver" },
        { value: "2", text: "Send" },
        // Add more options if needed
      ];

      const foundOption = appliedForOptions.find((option) => option.value === value);
      return foundOption ? foundOption.text : "Unknown"; // Default to "Unknown" if value doesn't match any option
    },
    openFormDialog() {
      this.resetAllowedCurrencyObj();
      console.log(this.allowedCurrencyObj);
      this.formDialogVisible = true;
      this.editedIndex = -1;
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    closeFormDialog() {
      this.formDialogVisible = false;
      this.$refs.form.reset();
    },
    deleteItem(index) {
      this.itemToDeleteIndex = index;
      this.dialogDelete = true;
    },
    closeDelete() {
      this.dialogDelete = false;
    },
    resetAllowedCurrencyObj() {
      // Reset the properties of allowedCurrencyObj
      this.allowedCurrencyObj.partner_id = this.$route.query.partner_id;
      this.allowedCurrencyObj.id = null;
      this.allowedCurrencyObj.country = localStorage.getItem("companyCountryCode");
      this.allowedCurrencyObj.currency_code = "";
      this.allowedCurrencyObj.currency_name = "";
      this.allowedCurrencyObj.is_default = false;
      this.allowedCurrencyObj.applied_for = "";
    },
    async editItem(item) {
      this.editedIndex = 1;
      console.log("item", item.id);
      this.currencyid = item.id;
      this.isEditing = true;
      this.formDialogVisible = true;
      await this.getcurrencybyid(item.id);

      // Populate the form fields with fetched data
      this.allowedCurrencyObj.currency_code = this.Currencybyid[0].currency_code;
      this.allowedCurrencyObj.currency_name = this.Currencybyid[0].currency_name;
      this.allowedCurrencyObj.is_default = this.Currencybyid[0].is_default;
      this.allowedCurrencyObj.applied_for = this.Currencybyid[0].applied_for;
      this.allowedCurrencyObj.partner_id = this.Currencybyid[0].partner_id;
      this.allowedCurrencyObj.id = this.Currencybyid[0].id;
    },

    async getAllcurrency() {
      this.loader = true;
      try {
        const responseData = await partnerService.getallAllowpartnerCurrency(
          this.$route.query.partner_id
        );
        if (responseData && responseData.data.status_code == 200) {
          this.AllpartnerCurrency = responseData.data.data.reverse();
          this.loader = false;
        }
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getAllcurrency();
        // }
        else {
          this.showAlertError("Failed:" + responseData.data.message);
        }
        console.log("AllpartnerCurrency", this.AllpartnerCurrency);
      } catch (e) {
        console.log(e);
        this.loader = false;
        this.showAlertError("Fetched data Failed: Something went wrong");
      }
    },
    async getcurrencybyid(id) {
      this.loader = true;
      try {
        const responseData = await partnerService.getallpartnerCurrencyid(id);
        if (responseData && responseData.data.status_code == 200) {
          this.Currencybyid = responseData.data.data.reverse();
          this.loader = false;
        }
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getcurrencybyid();
        // }
        else {
          this.showAlertError("Failed:" + responseData.data.message);
        }
        console.log("Currencybyid", responseData);
      } catch (e) {
        console.log(e);
        this.loader = false;
        this.showAlertError("Fetched data Failed: Something went wrong");
      }
    },
    // async submit() {
    // this.allowedCurrencyObj.country =
    //   localStorage.getItem("companyCountryCode");
    //   const validate = this.$refs.form.validate();
    //   if (validate) {
    //     this.loader = true;
    //     try {
    //       let response;
    //       if (this.isEditing) {
    //         response = await partnerService.Updatecurrency(
    //           this.currencyid,
    //           this.allowedCurrencyObj
    //         );
    //         this.showAlertSuccess(response.data.message);
    //         console.log("Update Response:", response);
    //       } else {
    //         response = await partnerService.PostPartnerCurrency(
    //           this.allowedCurrencyObj
    //         );
    //         if (response.data.status_code==200) {
    //           this.showAlertSuccess(response.data.message);
    //         } else {
    //           this.showAlertError(
    //             "An error occurred: " + response.data.message
    //           );
    //         }

    //         console.log("Add Response:", response);
    //       }
    //       this.loader = false;
    //       this.isEditing = false;
    //       this.closeFormDialog();
    //       this.getAllcurrency();
    //     } catch (error) {
    //       this.showAlertError("Failed to save currency: " + error.message);
    //     }
    //   }
    // },

    submit() {
      const validate = this.$refs.form.validate();
      if (validate) {
        if (this.allowedCurrencyObj.id) {
          this.update();
        } else {
          this.save();
        }
      }
    },

    async save() {
      this.loader = true;
      try {
        const responseData = await partnerService.PostPartnerCurrency(
          this.allowedCurrencyObj
        );
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess(responseData.data.message);
          this.closeFormDialog();
          this.getAllcurrency();
          this.loader = false;
        } else {
          this.showAlertError("Failed: " + responseData.data.message);
          this.loader = false;
        }
        console.log("Saved Data", responseData);
      } catch (e) {
        console.log(e);
        this.loader = false;
        this.showAlertError("Failed : Something went wrong");
      }
    },

    async update() {
      this.loader = true;
      try {
        const responseData = await partnerService.Updatecurrency(
          this.allowedCurrencyObj.id,
          this.allowedCurrencyObj
        );
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess(responseData.data.message);
          this.getAllcurrency();
          this.closeFormDialog();
          this.loader = false;
        } else {
          this.showAlertError("Failed:" + responseData.data.message);
          this.loader = false;
        }
        console.log("Update Data", responseData);
      } catch (e) {
        console.log(e);
        this.loader = false;
        this.showAlertError("Failed : Something went wrong");
      }
    },

    async deleteItemConfirm() {
      this.loader = true;
      try {
        setTimeout(() => {
          this.loader = false;
        }, 400);
        const itemToDelete = this.AllpartnerCurrency[this.itemToDeleteIndex];
        const responseData = await partnerService.deletePartnerCurrency(itemToDelete.id);
        this.response = responseData;
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess(responseData.data.message);
          this.getAllcurrency();
        }
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.deleteItemConfirm();
        // }
        else {
          this.showAlertError(responseData.data.message);
        }
      } catch (e) {
        console.log(e);
        this.showAlertError("One or more parameter is invalid or missing!");
      }

      this.closeDelete();
    },
    async isactiveupdate(isactive) {
      console.log("UpdatecurrencyStatus", isactive);
      this.loader = true;
      try {
        const responseData = await partnerService.UpdatecurrencyStatus(
          isactive.id,
          isactive.is_default,
          {}
        );
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess(responseData.data.message);
          this.getAllcurrency();
        }
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.isactiveupdate(isactive);
        // }
        else {
          this.showAlertError(responseData.data.message);
        }
        console.log("respose data", responseData);
      } catch (e) {
        console.log(e);
        this.showAlertError("Something went wrong please try again later.");
      }
      setTimeout(() => {
        this.loader = false;
      }, 400);
    },

    async getcurrencyList() {
      try {
        const response = await setupService.getcurrencydropdown(
          localStorage.getItem("companyCountryCode")
        );
        // if (response.status === 200) {
        //   this.currencyOptions = response.data.data[0].map((i) => {
        //     return { text: i.currency_name, value: i.currency_name };
        //   });
        // }
        if (response.status === 200) {
          console.log("response", response);
          this.currencyOptions = response.data.data[0].map((i) => ({
            text: i.currency_name,
            value: i.currency_name,
            currency_code: i.currency_code, // Store currency code with each option
          }));
        }

        console.log("countrys", response);
      } catch (e) {
        console.error(e);
        this.CountryList = [];
      }
    },
    updateCurrencyCode() {
      const selectedCurrency = this.currencyOptions.find(
        (currency) => currency.text === this.allowedCurrencyObj.currency_name
      );

      if (selectedCurrency) {
        this.allowedCurrencyObj.currency_code = selectedCurrency.currency_code;
      }
    },
  },
};
</script>

<style>
.required:after {
  content: " *";
  color: red;
}
</style>
